export default __webpack_public_path__ + "static/media/Amulet of Finesse.b502d44e.jpg";